import PropTypes from "prop-types";
import React, { Component } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

class PhotoWrapper extends Component {
    constructor(){
        super();
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.state = {
            visible: false
        };
    }

    show(){
        this.setState({visible: true});
    }

    hide(){
        this.setState({visible: false});    
    }

    render(){
        return (
            <div className="PhotoWrapper">
                <Card 
                    className="md-block-centered" 
                    onClick={this.show} 
                    style={{cursor: "zoom-in", marginRight: "2px"}}>
                    <CardContent>
                        <Typography variant="h6" style={{fontSize: 12}}>{`Photo ${this.props.number}`}</Typography>
                    </CardContent>
                    <CardContent>
                        <div className="PhotoContainer">
                            <img src={this.props.src} /> 
                        </div>
                    </CardContent>
                </Card>
                <div className="md-cell md-cell--12">
                    <Accordion 
                        defaultExpanded={this.props.tags ? this.props.tags.length > 0 : false}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Photo Tags</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {this.props.tags}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>Description</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {this.props.desc}
                        </AccordionDetails>
                    </Accordion>
                </div>
                <Dialog
                    id="case-photo-dialog"
                    open={this.state.visible}
                    onClose={this.hide}
                    sx={{ '& .MuiDialog-paper': { width: 'auto' } }}>
                    <DialogTitle>{this.props.tags ? this.props.tags : ""}</DialogTitle>
                    <DialogContent>
                        <img src={this.props.src} />
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

PhotoWrapper.propTypes = {
    src: PropTypes.string.isRequired,
    tags: PropTypes.string,
    desc: PropTypes.string,
    number: PropTypes.number
};

export default PhotoWrapper;
